import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CITIES } from '../data/cities';
import { MapPin, ArrowRight } from 'lucide-react';

const SITE = 'https://www.party-led.com';

const CitiesIndex = () => {
  const fr = CITIES.filter((c) => c.country === 'FR');
  const ae = CITIES.filter((c) => c.country === 'AE');
  const title = 'Bracelets LED par ville — France et Émirats arabes unis | Party LED';
  const description =
    "Nos kits de bracelets LED synchronisés sont livrés dans toute la France et aux Émirats arabes unis. Trouvez votre ville : Paris, Lyon, Marseille, Dubaï, Abu Dhabi et bien d'autres.";

  const Group = ({ heading, list }) => (
    <div className="mb-12">
      <h2 className="text-white text-lg md:text-lg font-semibold mb-5">{heading}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {list.map((c) => (
          <Link
            key={c.slug}
            to={`/bracelets-led-${c.slug}`}
            className="group bg-white/[0.02] border border-white/10 rounded-xl p-4 hover:border-purple-500/40 transition-colors"
            data-testid={`cities-index-${c.slug}`}
          >
            <p className="text-white text-sm font-medium flex items-center gap-2">
              <MapPin className="w-4 h-4 text-purple-400" />
              {c.name}
            </p>
            <p className="text-gray-500 text-xs mt-1">{c.region}</p>
          </Link>
        ))}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0b0b0c] pt-28 pb-20 px-6" data-testid="cities-index-page">
      <>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={`${SITE}/villes`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={`${SITE}/villes`} />
        <meta property="og:image" content={`${SITE}/og-image.jpg`} />
        <meta property="og:type" content="website" />
      </>

      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-4">
          <MapPin className="w-4 h-4 text-purple-400" />
          <p className="text-purple-400 text-xs tracking-[0.25em] uppercase">Nos villes</p>
        </div>
        <h1 className="text-white font-heading text-4xl sm:text-5xl font-bold tracking-tight mb-6">
          Bracelets LED dans toute la France et aux Émirats
        </h1>
        <p className="text-gray-300 text-base leading-relaxed mb-12">
          Nous livrons nos kits de bracelets LED synchronisés, prêts à l'emploi, partout en France et aux
          Émirats arabes unis. Choisissez votre ville pour découvrir nos animations lumineuses, nos formats
          de 50 à 1 000 personnes et demander votre devis.
        </p>

        <Group heading="France" list={fr} />
        <Group heading="Émirats arabes unis" list={ae} />

        <div className="bg-gradient-to-br from-purple-600/15 to-transparent border border-purple-500/25 rounded-2xl p-8">
          <h2 className="text-white text-lg md:text-lg font-semibold mb-2">Votre ville n'est pas listée ?</h2>
          <p className="text-gray-400 text-sm leading-relaxed mb-6">
            Nous livrons dans toute la France et aux Émirats. Dites-nous votre événement et votre ville :
            nous vous répondons avec le kit adapté sous 24 heures ouvrées.
          </p>
          <Link to="/devis">
            <Button className="bg-purple-600 hover:bg-purple-500 rounded-full px-8 py-6" data-testid="cities-index-quote">
              Demander mon devis
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CitiesIndex;
